import api from "../services/api";
import globalToast from "../components/common/globalToast";

const service_path = '/customers.php';

/**
 * Gera um link assinado de cadastro de cliente (validade em dias, padrão 7).
 * O token é assinado no servidor (HMAC) e validado no POST público.
 */
export async function getCustomerRegisterLink(ttlDays = 7) {
    const response = await api.get(`/customer-register-link.php?ttl_days=${ttlDays}`);
    return response.data;
};

export function getCustomers(filters = {}) {
    
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;
    
    const response = api.get(url);

    return response;
};

export function getCustomerDetails(id, setData) {

    api.get(`${service_path}?customer_id=${id}`)
        .then(response => {

            const { data } = response;

            if (data.success) {
                setData(data.customer_data);
            } else {
                globalToast.error('Houve um erro ao carregar o conteúdo desta página!');
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao carregar o conteúdo desta página!');
        });
};

export function createCustomer(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Cliente criado com sucesso!")
                navigateBack();
            } else {
                globalToast.error('Houve um erro criar esse usuário!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};

export function updateCustomer(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Cliente atualizado com sucesso!")
                navigateBack();
            } else {
                globalToast.error('Houve um erro ao atualizar esse usuário!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};

export function deleteCustomer(id, user_id) {

    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;

            if (data.success) {
                globalToast.success("Cliente deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse usuário!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};